import React, { useEffect, useMemo } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import { useInstData } from '../../hooks'
import ManagerInner from './ManagerInner'
import Waiting from '../Waiting'
import { mergeConfigs, pathNameToComponentName } from 'tyan/public/tyanInit/menuComponents/ManagerConfig/manager'

const mapStateToProps = ({ loginInfo: { roles } }) => ({ roles, })

const Manager = connect(mapStateToProps)(({ config: configProps, dispatch, history, location: { search = '', pathname }, match, roles, ...props }) => {
	const { me, setState, me: {
		tabs, allTabs, tabCounts,
		state: {
			defOK,
			configs
		}
	} } = useInstData(props, useMemo(() => {
		let configs = typeof configProps === 'function' ? configProps({ roles }) : configProps
		configs = configs.tabs || { '': configs }

		const allTabs = Object.keys(configs)

		return {
			allTabs, tabs: allTabs.length > 1 ? configs : null,
			state: {
				defOK: false,
				configs,
			}
		}
	}, []))

	const [, tabInUrl = ''] = decodeURIComponent(search).split('?')

	const tabName = configs[tabInUrl] ? tabInUrl : allTabs[0]

	const setTabCounts = v => me.tabCounts = v

	useEffect(() => {

		if (Tyan.menus.version < 2 || Tyan.sysMode === 'sample' || Tyan.appSettings.useMockData) {
			setState({ defOK: true, configs: mergeConfigs(null, configs) })
			return
		}

		// 从后台读取ManagerConfig
		const componentName = pathNameToComponentName(pathname)
		const component = Tyan.menus.allPaths[pathname]._component
		Tyan.doPostEvent('GetManagerConfig', {
			data: { componentName },
			onEnd: ({ errorMessage, config: managerConfig }) => {
				if (errorMessage) {
					!(errorMessage === '通讯异常: 404 - Not Found'
						|| errorMessage.startsWith('System.Exception: 没有处理函数的event'))
						&& (console.error(errorMessage), Ext.toast(`读取配置时错误 '${errorMessage}', 请与系统管理员联系`))
					setState({ defOK: true, configs: mergeConfigs(component, configs) })
					return
				}

				managerConfig = managerConfig ? JSON.parse(managerConfig) : {}

				const newConfigs = mergeConfigs(component, configs, managerConfig)

				setState({ defOK: true, configs: newConfigs })
			}
		})
	}, [])

	return !defOK
		? <Waiting />
		: tabName != tabInUrl
			? <Redirect to={`${pathname}${tabName ? `?${encodeURIComponent(tabName)}` : ''}`} />
			: <ManagerInner key={tabName} {...{
				config: configs[tabName], history, pathname,
				tabs, tabName, tabCounts, setTabCounts,
				...props
			}} />
})

export default Manager
